import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { CommerceHubProductIcon } from 'pricing-pages-ui-components/productIcon/CommerceHubProductIcons';
import { ContentHubProductIcon } from 'pricing-pages-ui-components/productIcon/ContentHubProductIcons';
import { DataHubProductIcon } from 'pricing-pages-ui-components/productIcon/DataHubProductIcons';
import { MarketingHubProductIcon } from 'pricing-pages-ui-components/productIcon/MarketingProductIcons';
import { SalesHubProductIcon } from 'pricing-pages-ui-components/productIcon/SalesHubProductIcons';
import { ServiceHubProductIcon } from 'pricing-pages-ui-components/productIcon/ServiceHubProductIcons';
import { SmartCrmProductIcon } from 'pricing-pages-ui-components/productIcon/SmartCrmProductIcons';
import { RevOsRename } from '../i18n/RevOsRename';
import { PublicPageHeader } from './PublicPageHeader';
import { jsx as _jsx } from "react/jsx-runtime";
function getHeaderContent(productGroup) {
  switch (productGroup) {
    case 'MARKETING':
      return {
        icon: /*#__PURE__*/_jsx(MarketingHubProductIcon, {}),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.marketing.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.marketing.subtitle"
        }, "subtitle")]
      };
    case 'SALES':
      return {
        icon: /*#__PURE__*/_jsx(SalesHubProductIcon, {}),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.sales.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.sales.subtitle"
        }, "subtitle")]
      };
    case 'SERVICE':
      return {
        icon: /*#__PURE__*/_jsx(ServiceHubProductIcon, {}),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.service.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.service.subtitle"
        }, "subtitle")]
      };
    case 'CONTENT':
      return {
        icon: /*#__PURE__*/_jsx(ContentHubProductIcon, {}),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.content.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.content.subtitle"
        }, "subtitle")]
      };
    case 'DATA':
      return {
        icon: /*#__PURE__*/_jsx(DataHubProductIcon, {}),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.data.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.data.subtitle"
        }, "subtitle")]
      };
    case 'COMMERCE':
      return {
        icon: /*#__PURE__*/_jsx(CommerceHubProductIcon, {}),
        title: /*#__PURE__*/_jsx(RevOsRename, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.header.commerce.title"
          })
        }),
        subtitles: [/*#__PURE__*/_jsx(RevOsRename, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.header.commerce.subtitle"
          })
        }, "subtitle"), /*#__PURE__*/_jsx(RevOsRename, {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "publicPricingPage.header.commerce.subtitle2",
            options: {
              viewPricingLink: /*#__PURE__*/_jsx(Link, {
                href: "#payments-section",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "publicPricingPage.header.commerce.viewPricingLink"
                })
              })
            }
          })
        }, "subtitle2")]
      };
    case 'SMART_CRM':
      return {
        icon: /*#__PURE__*/_jsx(SmartCrmProductIcon, {}),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.smartCrm.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.smartCrm.subtitle"
        }, "subtitle")]
      };
    case 'PLATFORM':
      return {
        icon: null,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.suite.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.suite.subtitle"
        }, "subtitle")]
      };
    case 'FREE':
      return {
        icon: null,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.free.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.free.subtitle"
        }, "subtitle")]
      };
    case 'HUBSPOT_FOR_MARKETERS':
      return {
        icon: null,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.marketingPlus.title"
        }),
        subtitles: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.header.marketingPlus.subtitle"
        }, "subtitle")]
      };
    default:
      return {
        icon: null,
        title: null,
        subtitles: []
      };
  }
}
export const PublicHubPageHeader = ({
  productGroup,
  subtitles: subtitleOverrides,
  children
}) => {
  const {
    icon,
    title,
    subtitles: defaultSubtitles
  } = getHeaderContent(productGroup);
  return /*#__PURE__*/_jsx(PublicPageHeader, {
    icon: icon,
    title: title || undefined,
    subtitles: subtitleOverrides || defaultSubtitles,
    children: children
  });
};